import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: 8px;
	height: 100%;
	min-height: 0;
	flex: 1;
`;

export const Label = styled.div`
	height: 36px;
	user-select: none;
	display: flex;
	align-items: center;

	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const Children = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;
